var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 70,
    viewBox: "0 0 56 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.096 32.5165C55.9423 33.6962 55.9423 36.393 54.096 37.5726L4.87834 69.0188C2.88141 70.2946 0.263112 68.8604 0.263112 66.4907L0.263114 3.59846C0.263115 1.22874 2.88141 -0.205458 4.87834 1.07042L54.096 32.5165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVPlay);
export default __webpack_public_path__ + "static/media/v-play.9d98f8f790ac51d642d1b80e1e5af364.svg";
export { ForwardRef as ReactComponent };